import { useEffect, useState } from "react";
import { reportDashboardApi } from "../../services/api";

// Small in-memory cache so switching sections (or sections sharing an endpoint) does not refetch.
const cache = new Map();
const TTL_MS = 60000;

const fetchCached = (section, req) => {
  const key = section + JSON.stringify(req);
  const hit = cache.get(key);
  if (hit && Date.now() - hit.t < TTL_MS) return hit.p;
  const p = reportDashboardApi.section(section, req);
  cache.set(key, { t: Date.now(), p });
  p.catch(() => cache.delete(key));
  return p;
};

export const clearReportCache = () => cache.clear();

export function useReportData(section, req, enabled = true) {
  const key = section + JSON.stringify(req);
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null }));
    fetchCached(section, req)
      .then((data) => { if (!cancelled) setState({ data, loading: false, error: null }); })
      .catch((e) => {
        if (cancelled) return;
        const msg = e?.response?.data?.errors?.[0]?.detail || e?.response?.data?.message || e?.message || "Failed to load";
        setState((s) => ({ ...s, loading: false, error: msg }));
      });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, nonce, enabled]);

  return { ...state, reload: () => { cache.delete(key); setNonce((n) => n + 1); } };
}